import z from "zod";

export const SchoolPreferencesSchema = z
  .object({
    interestedInAll: z.boolean(),
    selectedSchools: z.array(z.string()),
    openToOther: z.boolean(),
  })
  .nullable();
